import React, { useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { updatePaymentStatus } from "../../../store/actions/centerActions/payment";

/*
 * Payment return page (/center/payment).
 *
 * The normal Razorpay flow completes inside the Add Student page - Checkout
 * opens in a modal and the payment is recorded there, so this page is not
 * part of that path.
 *
 * It previously read Instamojo's payment_id / payment_status /
 * payment_request_id from useParams(), but the route declares no URL
 * parameters, so those were always undefined and the page fired a broken
 * request on every visit. It now only posts when a real Razorpay payment id
 * is present (route param or query string) and otherwise just says so.
 */
const Payment = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { search } = useLocation();
  const [data, setData] = useState("Processing...");

  const query = new URLSearchParams(search);
  const paymentId =
    params.razorpay_payment_id || query.get("razorpay_payment_id") || "";
  const studentId = params.student_id || query.get("student_id") || "";

  const fetchDetails = useCallback(async () => {
    if (!paymentId) {
      setData("No payment to confirm.");
      return;
    }

    const formdata = new FormData();
    formdata.append("razorpay_payment_id", paymentId);
    if (studentId) formdata.append("student_id", studentId);

    const response = await dispatch(updatePaymentStatus(formdata));
    setData(
      response && response.message
        ? response.message
        : "Could not confirm the payment. Please contact the council."
    );
  }, [paymentId, studentId, dispatch]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  return <div>{data}</div>;
};

export default Payment;
